import { apiClient } from '~/api/client';

type IndexParams = {
  name: string;
  type: 'LoanOfficerCompany' | 'RealtorCompany';
};

type IndexResponse = {
  name: string;
}[];

export const index = async (params: IndexParams) =>
  apiClient.get<IndexResponse>(`/companies?name=${params.name}&type=${params.type}`);
